/* eslint-disable max-lines */
import get from 'lodash/get';
import mapValues from 'lodash/mapValues';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import debounce from 'lodash/debounce';
import isNil from 'lodash/isNil';
import { trackAuctionBlockOpen, trackAuctionBlockChangeBid, trackAuctionMoreInfoClick } from './auction.tracking';
import { trackShowCheckbox } from './demand.tracking';
import { trackRefillByCardModalOpen } from './payByCard.tracking';
import { unavailableReasons, pluralize as pluralizeDic, hints, hintsML, unavailableReasonsML } from './dictionaries';
import {
  hasPaidPackage,
  getPaidPackage,
  getDefaultPackage,
  getPaidPeriod,
  getDefaultPeriod,
  isOptionElementPaid,
  hasPaidPackageOrPeriod,
  getPaidPackageOrPeriod,
  getPrice,
  getPriceBeforeDiscount,
  getDiscount,
  hasPackages,
  hasDiscount,
  isAdditionalTermCompatible,
  isAutobrokerCompatible,
  getHintImageUrl,
  isHighDemandIconShow,
  isObjectSplitsCategory,
  isDailySelected,
  isSubscriptionOption,
} from './utils';
import { keepValueInRange, getNearestUpperMultiple, plural } from '@cian/utils';
import checkServiceModal from './check-service/check-service-modal.jade';
import { getGALabel, trackPayClick } from './tracking';
import { ca } from '@cian/analytics';
import multiPostingFireIcon from './multiPosting/images/fire.png';
import { getPlatforms } from './utils/multiPosting/getPlatforms.jsm';
import { getText } from './utils/multiPosting/getText.jsm';
import { selectConfigValue } from '../../../shared/selectors/config';
import { selectDynamicPricingParameters, selectOfferId } from '../../../shared/selectors/offer';
import { selectIsSaveDraftButtonAvailable } from '../../../shared/selectors/checkoutInfo';
import { getLabelText } from '../../../shared/utils/multiposting/getLabelText';
import { getIsCommercial } from '../../../shared/utils/category/getIsCommercial';

export default function (
  $rootScope,
  $scope,
  $sce,
  $filter,
  $uibModal,
  placingTermsApi,
  popupService,
  cardPaymentService,
  userService,
  analyticsService,
  advertiseObjectService,
  auctionApi,
  demandApi,
  addFormService,
  adStateService,
  urlService,
  addressService,
  deviceService,
  telemetryService,
  config,
  store,
  geoService,
  $document,
) {
  'ngInject';

  const state = store.getState();
  const offerId = selectOfferId(state);
  const { abExperiments } = state;
  const { isMobile } = deviceService;

  this.isMobile = isMobile;
  this.isAreaParts = isObjectSplitsCategory(this.category) && addFormService.ad.areaParts;

  telemetryService.mark('terms.init-start');
  telemetryService.sendMeasuredTimer(
    'terms.publish-terms-segment-init-to-component-init-start',
    'addform.publish-terms-segment-init',
    'terms.init-start',
  );

  $scope.isDefined = value => !isNil(value);
  $scope.multiPostingFireIcon = multiPostingFireIcon;

  this.isSubAgent = this.isSubAgentAsString === 'true';
  this.isSubAgentWithSpendLimit = this.isSubAgentWithSpendLimitAsString === 'true';

  this.subAgentUsesMastersMoney = this.isSubAgent && this.subAgentMoneySource === 'master';

  this.isSaleCategory = this.category.toLowerCase().indexOf('sale') !== -1;
  this.isByHomeowner = addFormService.ad.isByHomeowner;
  this.demandTrapDescription = this.isSaleCategory
    ? 'Поможет быстро найти покупателя, организует показы и безопасно проведёт сделку'
    : 'Быстро найдёт арендаторов, проведёт показы и поможет правильно составить договор';

  // Тут хранится выбор для отправки на сервер
  this.publishTerms = placingTermsApi.publishTerms;

  // Модель чекбокса, если true - пользователь разрешил рекламу объекта
  this.advertiseMyObjectEnable = userService.enableAdvertiseMyObject;
  // Поле для хранения группы эксперимента: null / 'A' / 'B'
  this.adMyObjectABGroup = null;
  // Хинт под чекбоксом
  this.adMyObjectHintText = 'Они помогут совершить сделку в нужный срок по максимальной цене';
  // Текст для варианта A (call)
  this.adMyObjectTooltipTextVariantA =
    'Проверенное ЦИАН агентство профессионально оценит ваш объект, бесплатно опубликует рекламу и проконсультирует по всем вопросам';
  // Текст для варианта Б (advertise)
  this.adMyObjectTooltipTextVariantB =
    'Проверенное ЦИАН агентство бесплатно опубликует рекламу вашего объекта и свяжется с вами только в случае появления потенциального клиента';
  // Получаем текст тултипа в зависимости от аб группы
  this.getAdMyObjectTooltipText = () => {
    if (this.adMyObjectABGroup === 'A') {
      return this.adMyObjectTooltipTextVariantA;
    }
    if (this.adMyObjectABGroup === 'B') {
      return this.adMyObjectTooltipTextVariantB;
    }

    return '';
  };

  this.toggleIsRealtorHelpNeeded = () => {
    placingTermsApi.isRealtorHelpNeeded = !placingTermsApi.isRealtorHelpNeeded;
  };

  // Переключаем чекбокс
  this.toggleAdMyObject = () => {
    userService.enableAdvertiseMyObject = !userService.enableAdvertiseMyObject;

    this.advertiseMyObjectEnable = userService.enableAdvertiseMyObject;
  };
  // Устанавливаем чекбокс
  this.setAdMyObjectStatus = newValue => {
    userService.enableAdvertiseMyObject = newValue;
    this.advertiseMyObjectEnable = newValue;
  };
  // Виден ли чекбокс вообще (зависит от категории объявления)
  this.advertiseMyObjectVisible = false;

  // Виден ли чекбокс ловушки в спрос (зависит от наличия заявки у пользователя)
  this.showDemandTrap = false;

  const experimentName = config.get('dealRentTraps.experiment.name');
  this.isInExperiment = abExperiments[experimentName] === '2';

  this.openHintModal = () => {
    if (!this.isMobile) {
      return;
    }

    popupService.openPopup('hint', {
      text: this.multiPostingData.tooltipText,
      title: '',
      hideCloseButton: true,
    });
  };

  this.hasActiveMessages = null;
  // Загружаем юзера и смотрим какая A/B группа рекламы объекта
  userService.getUser().then(user => {
    if (user.freeProfessionalHelpBlockVariant === 'call') {
      this.adMyObjectABGroup = 'A';
      this.advertiseMyObjectVisible = advertiseObjectService.isCanAdvertiseObject();
    }
    if (user.freeProfessionalHelpBlockVariant === 'advertise') {
      this.adMyObjectABGroup = 'B';
      this.advertiseMyObjectVisible = advertiseObjectService.isCanAdvertiseObject();
    }

    if (!user.freeProfessionalHelpBlockVariant) {
      this.advertiseMyObjectVisible = false;
    }

    // Проверяем, показали ли мы чекбокс, чтобы отправить аналитику
    if (this.advertiseMyObjectVisible) {
      analyticsService.trackAdvertiseCheckboxShow();
    }

    demandApi.getUserHasActiveMessage(user.userId).then(({ data }) => {
      this.hasActiveMessages = data.hasActiveMessages;
      this.showDemandTrap =
        this.isByHomeowner &&
        !this.hasActiveMessages &&
        (this.isInExperiment || !get(addFormService, 'ad.dealRentData.applyDealRentVersion'));

      if (this.showDemandTrap) {
        trackShowCheckbox(adStateService.isNewOffer);
      }
    });
  });

  // Скрыть ли ФормуВыбораУслуг
  this.isHidden = false;

  // For ng-bind-html
  this.$sce = $sce;

  // Словари для склонения чисел
  this.pluralize = pluralizeDic;

  $rootScope.$watch(
    () => placingTermsApi.selected,
    () => {
      this.selected = placingTermsApi.selected;
    },
  );

  $rootScope.$watch(
    () => placingTermsApi.isHidden,
    () => {
      this.isHidden = placingTermsApi.isHidden;
    },
  );

  $rootScope.$watch(
    () => this.isMultiPostingChecked,
    () => {
      addFormService.ad.multiposting = {
        enabled: this.isMultiPostingChecked,
      };
    },
  );

  this.canPayByCard = () => {
    return userService.user.canPayByCard || false;
  };

  this.shouldPayByCard = placingTermsApi.shouldPayByCard;
  this.showRefillAccountPopup = placingTermsApi.showRefillAccountPopup;

  this.shouldDisplayError = () => {
    return !cardPaymentService.getState() && placingTermsApi.shouldPayByCard();
  };

  this.handleRefillLinkClick = () => {
    if (placingTermsApi.isNotEnoughMoney) {
      placingTermsApi.showRefillAccountPopup('balance');
    } else {
      trackRefillByCardModalOpen('balance', analyticsService.adAnalyticsCategory);

      popupService.openPopup('payByCard', { options: { source: 'refill' } });
    }
  };

  this.autoprolongCheckServiceData = {};

  this.isAutoprolongAvailable = () => {
    return placingTermsApi.isAutoprolongAvailable();
  };

  this.isMultiPostingAvailable = () => {
    return placingTermsApi.isMultiPostingAvailable;
  };

  this.toggleMultiPosting = () => {
    this.isMultiPostingChecked = !this.isMultiPostingChecked;
  };

  this.getAutoprolongHintText = () => {
    return this.autoprolongCheckServiceData && this.autoprolongCheckServiceData.hintText;
  };

  this.getAutoprolongTooltipText = () => {
    return this.autoprolongCheckServiceData && this.autoprolongCheckServiceData.tooltipText;
  };

  this.openAutoprolongTooltipModal = () => {
    popupService.openPopup('hint', {
      text: this.getAutoprolongTooltipText(),
      title: 'Автопродление',
    });
  };

  this.openAdMyObjectTooltipModal = () => {
    popupService.openPopup('hint', {
      text: this.getAdMyObjectTooltipText(),
      title: 'Реклама объекта',
    });
  };

  this.openDemandTrapTooltipModal = () => {
    popupService.openPopup('hint', {
      text: 'Информация об объекте и ваши контакты будут отправлены риэлтору. Он свяжется с вами в ближайшее время, проконсультирует и ответит на любые вопросы.',
      title: 'Помощь риэлтора',
    });
  };

  this.getTitle = errorMessage => {
    const titles = {
      none: 'Условия размещения',
      needTariff: 'Для размещения объявления требуется профессиональный тариф',
      noTariff: 'Требуется активация дополнительного региона',
      subAgentLimitExceed: get(errorMessage, 'data.title'),
    };

    const errorType = get(errorMessage, 'type', 'none');

    return titles[errorType];
  };

  // Utilities
  const onTermsChanged = handler => $rootScope.$on('terms.changed', handler);
  const fireTermsChanged = () => $rootScope.$emit('terms.changed');

  /**
   * Сохраняем данные для отправки на сервер
   * @param isAfterUpdate - true если вызван после обновления услуг с сервера
   */
  const save = isAfterUpdate => {
    const currentPeriod = placingTermsApi.getCurrentPeriodFromSelected();

    if (!currentPeriod) {
      return;
    }

    const { selected, auctionOption, getAllSelectedServices, processPublishTerm, isAutobrokerEnabled } =
      placingTermsApi;

    if (!selected.option.hasOwnProperty('id')) {
      throw new Error('Выбранная опция не содержит поле id');
    }

    // Включён автоброкер и текущий Сервис совместим с автоброкером
    const isAutobrokerEnabledAndCompatible =
      isAutobrokerEnabled && isAutobrokerCompatible(selected.option, auctionOption);
    // Есть ставка Аукциона
    const isAuctionPaid = !isAutobrokerEnabled && Boolean(auctionOption && auctionOption.dynamicPrice);

    this.publishTerms.terms = [];

    // Сохраняем все выбранные опции
    getAllSelectedServices().forEach(option => {
      const termData = processPublishTerm(option);

      // Если dynamicPrice аукциона undefined|null|0, не добавляем его
      if (
        // Все сервисы, кроме Аукциона
        !option.services?.includes('auction') ||
        isAutobrokerEnabledAndCompatible ||
        isAuctionPaid
      ) {
        this.publishTerms.terms.push(termData);
      }
    });

    // если используется check-service, то перед запросом мы должны передать текущее значение авотопродления - true / false
    if (this.isAutoprolongAvailable()) {
      this.publishTerms.autoprolong = placingTermsApi.terms.autoProlong;
    } else {
      this.publishTerms.autoprolong = false;
    }

    placingTermsApi.setTerms(this.publishTerms, isAfterUpdate);
  };

  const isHighDemand = () => placingTermsApi.terms.isHighDemand;
  $scope.getDemandCoefficient = () => placingTermsApi.terms.highDemandCoefficient;
  $scope.isHighDemandIconShow = option => isHighDemandIconShow({ option, placingTermsApi });
  $scope.isHighDemandShown = () => isHighDemand() && $scope.getDemandCoefficient() != null;

  $scope.getIsCommercial = () => getIsCommercial(this.category);

  /**
   * Проверяем доступность выбранных сервисов, если сервисы недоступны - показываем сообщение
   * и по закрытию обновляем список услуг.
   * @param noRefreshOnClose - true - если не надо обновлять список услуг после закрытия сообщения о недоступности,
   * применяется после обновления услуг с сервера для исключения рекурсии
   * @return {Promise}
   */
  const checkServiceAvailability = noRefreshOnClose => {
    placingTermsApi
      .checkService()
      .then(data => {
        if (!data.isAvailable && data.unavailableCheckServiceMessage) {
          const modalWrapper = document.querySelector('.modal-wrapper');
          const $modalWrapper = angular.element(modalWrapper);

          const mobileModalConfig = isMobile && {
            appendTo: $modalWrapper,
            openedClass: 'modal-open',
          };

          const modalInstance = $uibModal.open({
            template: checkServiceModal,
            ...mobileModalConfig,
          });

          if (isMobile) {
            $modalWrapper.addClass('modal-open');
            $document.find('body').addClass('modal-body-wrapper');
          }

          modalInstance.closed.finally(() => {
            if (!noRefreshOnClose) {
              placingTermsApi.updateTerms();
            }

            if (isMobile) {
              $modalWrapper.removeClass('modal-open');
              $document.find('body').removeClass('modal-body-wrapper');
            }
          });
        }

        setInsufficientFundsWarning(data.insufficientFunds);

        if (isObject(data.autoProlongInfo)) {
          this.autoprolongCheckServiceData = {
            ...data.autoProlongInfo,
          };
        }

        return data;
      })
      .then(data => {
        this.totalPriceAmount = get(data, 'writeOff.amount');

        this.totalPriceDefined = this.totalPriceAmount >= 0;

        const isNotEnoughMoney = data.insufficientFunds;

        placingTermsApi.setNotEnoughMoney(isNotEnoughMoney);
        placingTermsApi.setTotalPriceAmount(this.totalPriceAmount);

        this.selected = placingTermsApi.selected;

        // Триггерим save после завершения работы checkService, чтобы актуализировать автопролонгацию
        save(true);
      });
  };

  const checkServiceAvailabilityDebounced = debounce(checkServiceAvailability, 300);

  const formatDate = date => {
    return $filter('date')(date, 'longDate');
  };

  this.formatDate = formatDate;

  const setInsufficientFundsWarning = show => (this.showInsufficientFundsWarning = !!show);

  // Субагент узнаёт о недостатке денег только во время публикации.
  this.showInsufficientFundsWarningForAdditional = option => {
    return this.isAdditionalSelected(option) && this.showInsufficientFundsWarning;
  };

  this.showInsufficientFundsWarningForRegular = option => !option.isAdditional && this.showInsufficientFundsWarning;

  // Срабатывает при выборе опции
  $scope.selectOption = placingTermsApi.selectOption;
  this.selectPeriod = placingTermsApi.selectPeriod;

  this.toggleRenew = () => {
    fireTermsChanged();
  };

  // при изменении услуг пользователем
  const removeTermsChangedHandler = onTermsChanged(() => {
    save();

    checkServiceAvailabilityDebounced();
  });

  // Checks

  // Выбрана услуга, например "Премиум", услуга рендерится как радио
  this.isSelected = placingTermsApi.isSelected;

  // Выбрана опция, например "Выделение цветом", опция рендерится как чекбокс
  this.isAdditionalSelected = placingTermsApi.isAdditionalSelected;

  this.isDisabled = placingTermsApi.isDisabled;

  this.isDailySelected = () => isDailySelected(placingTermsApi);

  this.isMultiPostingChecked = addFormService.ad.multiposting ? addFormService.ad.multiposting.enabled : false;

  // Проверяем paidTill, чтобы не считать оплаченными услуги, подключенные бессрочно
  this.isPaid = option => (option.selectedPeriod ? !!option.selectedPeriod.paidTill : false);

  $scope.hasDiscount = hasDiscount;

  this.isBalanceShown = () => this.subAgentUsesMastersMoney || !!this.balance;
  const getSubagentBalanceLabel = () =>
    this.isSubAgentWithSpendLimit ? 'Доступный лимит средств' : 'Баланс агентства';
  this.getBalanceLabel = () => (this.subAgentUsesMastersMoney ? getSubagentBalanceLabel() : 'Баланс');
  this.getBalanceValue = () => (this.subAgentUsesMastersMoney ? this.agencyBalance : this.balance);

  this.showBalanceText = () =>
    !this.subAgentUsesMastersMoney || this.isSubAgentWithSpendLimit || this.subAgentCanViewAgencyBalance;

  // Gets

  $scope.getPrice = getPrice;
  $scope.getPriceBeforeDiscount = getPriceBeforeDiscount;
  $scope.getDiscount = getDiscount;

  // Period methods

  this.getPeriodType = option => {
    if (this.isPaid(option)) {
      return option.isAdditional ? 'paidAdditional' : 'paid';
    }
    if (hasPackages(option)) {
      return 'packages';
    }
    if (option.publishOptions.periods.length === 1) {
      return 'singleOption';
    }

    return 'switcher';
  };

  this.isPeriodVisible = option => {
    if (!option.isAvailable) {
      return false;
    }

    if (option.isAdditional) {
      return !this.isDisabled(option);
    }

    if (option.selectedPeriod && option.selectedPeriod.isPaid && !option.hasTabs) {
      return false;
    }

    return this.isSelected(option);
  };

  this.isTermlessSelected = option => (option.selectedPeriod ? option.selectedPeriod.type === 'dailyTermless' : false);

  this.getEndDate = option => {
    return formatDate(option.selectedPeriod.paidTill || option.selectedPeriod.endDate);
  };

  this.getPeriodDays = option => {
    const currentPeriod = option.selectedPeriod;

    // Для daily-тарифов цена указывается за сутки
    return currentPeriod.type === 'dailyLimited' ? 1 : currentPeriod.days;
  };

  // Причины недоступности

  let unavailableReasonsWithHtml = mapValues(unavailableReasons, r => ({
    ...r,
    html: $sce.trustAsHtml(r.hint),
  }));

  const getUnavailableReasonProperty = property => option => {
    const reason = unavailableReasonsWithHtml[option.unavailableReasonType];

    return reason && reason[property];
  };

  this.getUnavailableReasonHint = getUnavailableReasonProperty('html');
  this.getUnavailableReasonMessage = getUnavailableReasonProperty('message');

  // Считаем общее число пакетов для опции, если нет пакетов - 0
  this.getTotalPackagesCount = option =>
    hasPackages(option)
      ? option.publishOptions.servicePackages.reduce(
          (acc, { servicePackageActualCount }) => acc + servicePackageActualCount,
          0,
        )
      : 0;

  // TODO getPaidPeriod & getPaidPackage могут быть объединены если будем искать по одинаковому свойству
  // Пока так, потому что на данный момент нельзя найти оплаченный пакет
  this.getPaidPackage = optionPackages => optionPackages.find(({ activeTill }) => activeTill);
  this.getPaidPeriod = optionPeriods => optionPeriods.find(({ activeTill }) => activeTill);

  this.onPackagesTabSelect = option => {
    // Если есть оплаченный пакет выбираем его
    if (hasPaidPackage(option)) {
      option.selectedPeriod = getPaidPackage(option);
    } else {
      option.selectedPeriod = getDefaultPackage(option);
    }

    this.selectPeriod(option);
  };

  this.onPeriodsTabSelect = option => {
    option.selectedPeriod = getPaidPeriod(option) || getDefaultPeriod(option);

    this.selectPeriod(option);
  };

  this.areTabsAvailable = option => option.hasTabs;

  this.isOptionElementPaid = isOptionElementPaid;

  // Если опция выбрана и выбранный период или пакет оплачен
  // Или если опция не выбрана, но есть оплаченный период или пакет
  this.showActiveTill = option => {
    if (!option) {
      return;
    }

    const isSelected = option.isAdditional ? this.isAdditionalSelected(option) : this.isSelected(option);

    return isSelected ? option.selectedPeriod && option.selectedPeriod.isPaid : hasPaidPackageOrPeriod(option);
  };

  $scope.getSummaryOptionTitle = option => {
    switch (option.id) {
      case 'calltracking':
        return 'Защита номера';

      case 'auction':
        return 'Ставка по аукциону';

      default:
        return option.name;
    }
  };

  $scope.isAuctionOptionValid = option => {
    const { isAutobrokerEnabled, selected, auctionOption } = placingTermsApi;

    return option.services.includes('auction') && isAutobrokerEnabled
      ? isAutobrokerCompatible(selected.option, auctionOption)
      : true;
  };

  const hideAllHints = () => {
    this.placingTerms.map(option => {
      option.showHint = false;
    });

    if (placingTermsApi.auctionOption) {
      placingTermsApi.auctionOption.showHint = false;
    }
  };

  // Автоброкер ↓
  // Текст-описание выбранной стратегии
  $scope.getAutobrokerStrategyText = () => {
    const { auctionOption } = placingTermsApi;

    return auctionOption && auctionOption.auctionStrategyInfo && auctionOption.auctionStrategyInfo.strategyName;
  };

  // Показываем блок только если пользователь выбрал стратегию автоброкера и Сервис выбран
  $scope.isAutobrokerHintVisible = option => placingTermsApi.isAutobrokerEnabled && this.isSelected(option);
  // Автоброкер ↑

  this.mouseOverOption = (e, option) => {
    e.stopPropagation();

    if (option.isAvailable) {
      hideAllHints();

      option.showHint = true;
    }
  };

  this.mouseLeaveOption = (e, option) => {
    e.stopPropagation();

    if (option.isAvailable) {
      hideAllHints();

      if (placingTermsApi.selected) {
        placingTermsApi.selected.option.showHint = true;
      }
    }
  };

  const sendGA = (option, button) => {
    if (option.id === 'highlight') {
      return;
    }

    const name = getGALabel(placingTermsApi.selected.additionals, option.id);
    const event = {
      name: 'oldevent',
      category: analyticsService.adAnalyticsState,
      action: `popup_rentFaster_${name}_show`,
      user: this.userId,
      label: '',
    };

    if (button) {
      event.label = getGALabel(placingTermsApi.selected.additionals, option.id);
      event.action = `popup_rentFaster_${name}_click`;
    }

    ca('event', event);
  };

  this.changeSelect = (button, $event, option) => {
    $event.preventDefault();
    $event.stopPropagation();
    let newOption;
    if (button.id === 'premium+highlight' || button.id === 'top3') {
      newOption = this.placingTerms.find(term => term.id === button.id);
    }
    sendGA(option, button);
    placingTermsApi.selectOption(newOption);
  };

  this.optionGetPaidPackageOrPeriod = getPaidPackageOrPeriod;

  const mlRegions = selectConfigValue('mlOffersRankingEnabledRegions', state);

  // Картинки для хинтов
  $scope.getHintImageUrl = getHintImageUrl;
  $scope.getHint = id => {
    if (Array.isArray(mlRegions) && this.locationPath && mlRegions.some(region => this.locationPath.includes(region))) {
      return hintsML[id];
    } else {
      return hints[id];
    }
  };

  this.isCalltrackingTermSelected = placingTermsApi.isCalltrackingTermSelected;
  this.calltrackingOption = placingTermsApi.calltrackingOption;
  this.getCalltrackingPrice = () => getPrice(placingTermsApi.calltrackingOption);

  $scope.isAdditionalCompatible = isAdditionalTermCompatible;

  // Аукцион ↓
  $scope.isAuctionChangeTermPopupShow = false;

  $scope.auctionFirstPageBet = undefined;
  $scope.auctionFirstPlaceBet = undefined;

  $scope.isAutobrokerCompatible = () =>
    isAutobrokerCompatible(placingTermsApi.selected.option, placingTermsApi.auctionOption);

  const getTopBets = () => {
    $scope.isAuctionTopDataFetching = true;
    $scope.isAuctionTopDataSuccess = false;

    const betPositionRequest = auctionApi.getBetPositionForecast(this.auctionBet);
    const topBetsRequest = auctionApi.getTopBetsByAnnouncement();

    Promise.all([betPositionRequest, topBetsRequest])
      .then(([{ data: betPositionResponse }, { data: topBetsResponse }]) => {
        $scope.isAuctionTopDataFetching = false;
        $scope.isAuctionTopDataSuccess = true;
        $scope.auctionTopData = {
          ...betPositionResponse,
          ...topBetsResponse,
        };
      })
      .catch(() => {
        $scope.isAuctionTopDataFetching = false;
      });

    if (shouldAuctionRecommendedBetLinkRequest()) {
      auctionApi.getLeadingBetsByAnnouncement(this.auctionBet).then(({ data: { firstPageBet, firstPlaceBet } }) => {
        $scope.auctionFirstPageBet = firstPageBet;
        $scope.auctionFirstPlaceBet = firstPlaceBet;
      });
    }
  };

  $scope.isPenetratingConcurrencyEnabled = () => {
    return (
      $scope.auctionTopData &&
      Number.isFinite($scope.auctionTopData.betFullConcurrency) &&
      Number.isFinite($scope.auctionTopData.betServiceConcurrency)
    );
  };

  $scope.getConcurrencyServiceName = () => {
    const selectedOption = placingTermsApi.selected.option.id;

    const betServiceConcurrency = $scope.auctionTopData.betServiceConcurrency;

    const SERVICE_IDS_MAP = {
      paid: 'paid',
      premium: 'premium',
      'premium+highlight': 'premium',
      top3: 'top3',
    };

    const SERVICE_NAMES_MAP = {
      paid: plural(betServiceConcurrency, ['Платное', 'Платных', 'Платных']),
      premium: 'Премиум',
      top3: 'Топ',
    };

    return SERVICE_NAMES_MAP[SERVICE_IDS_MAP[selectedOption]];
  };

  $scope.notTop3 = () => {
    const selectedOption = $scope.getConcurrencyServiceName();

    return selectedOption !== 'Топ';
  };

  const applyAuctionBet = () => {
    placingTermsApi.auctionOption.dynamicPrice = this.auctionBet;
    placingTermsApi.auctionOption.selectedPeriod.price = this.auctionBet;
  };

  const initializeAuctionBet = () => {
    const { auctionOption } = placingTermsApi;

    if (!auctionOption) {
      return;
    }

    if (auctionOption.isAuctionBetHolded) {
      placingTermsApi.selectAdditional(placingTermsApi.auctionOption);
    }

    if (!adStateService.isNewOffer) {
      auctionOption.selectedPeriod.price = auctionOption.sourceBet;
    }

    $scope.auctionBetMaxLength = String(placingTermsApi.auctionMaxBet).length;

    applyAuctionBet();
    getTopBets();
  };

  const handleAuctionChange = () => {
    const { auctionOption } = placingTermsApi;

    if (!auctionOption) {
      return;
    }

    applyAuctionBet();
    fireTermsChanged();
    getTopBets();

    calcAuctionProgress();

    trackAuctionBlockChangeBid();
  };

  $scope.handleAuctionChange = debounce(handleAuctionChange, 400);

  const setAuctionBet = value => {
    const auctionBet = this.auctionBet || 0;

    if (auctionBet === placingTermsApi.auctionMaxBet) {
      return;
    }

    const bet =
      typeof value === 'undefined'
        ? // Инкремент текущей ставки
          getNearestUpperMultiple(auctionBet + 1, placingTermsApi.stepBet)
        : // Устанавливаем переданную ставку
          value;

    // Не даём поднять ставку выше максимальной
    this.auctionBet = Math.min(bet, placingTermsApi.auctionMaxBet);

    calcAuctionProgress();

    $scope.handleAuctionChange();
  };
  $scope.setAuctionBet = setAuctionBet;

  $scope.isAuctionTopPopupOpen = false;

  $scope.showAuctionTopPopup = isShow => {
    $scope.isAuctionTopPopupOpen = isShow;
  };

  const isAuctionSelected = () =>
    (placingTermsApi.auctionOption && placingTermsApi.auctionOption.isAuctionBetHolded) ||
    this.isAdditionalSelected(placingTermsApi.auctionOption);
  $scope.isAuctionSelected = isAuctionSelected;

  let isAuctionSelectedFirstTime = false;

  $scope.handleAuctionClick = $event => {
    $event.preventDefault();
    $event.stopPropagation();

    const { auctionOption } = placingTermsApi;

    if (!auctionOption || auctionOption.isAuctionBetHolded) {
      return;
    }

    if (!isAuctionSelected()) {
      this.auctionBet = auctionOption.sourceBet || 5;

      applyAuctionBet();
    }

    placingTermsApi.selectOption(auctionOption);

    if (isAuctionSelected()) {
      initializeAuctionBet();

      if (!isAuctionSelectedFirstTime) {
        trackAuctionBlockOpen(auctionOption.isAuctionBetHolded);

        isAuctionSelectedFirstTime = true;
      }
    }
  };

  $scope.handleAuctionMoreInfoClick = $event => {
    $event.preventDefault();
    $event.stopPropagation();

    trackAuctionMoreInfoClick();
  };

  const shouldAuctionRecommendedBetLinkRequest = () => {
    const { auctionOption } = placingTermsApi;

    // Аукцион доступен
    return (
      auctionOption &&
      // Нет удержания ставки на аккаунт
      !auctionOption.isAuctionBetHolded &&
      // Объявление в аукционе
      (auctionOption.selectedPeriod.isPaid ||
        // Объявление не в аукционе
        (!auctionOption.selectedPeriod.isPaid &&
          // Пользователь изменил ставку
          addFormService.form['auctionBet'] &&
          addFormService.form['auctionBet'].$dirty))
    );
  };

  const auctionBetValidate = () => {
    return placingTermsApi.auctionBetValidate(
      placingTermsApi.auctionOption && placingTermsApi.auctionOption.dynamicPrice,
      placingTermsApi.stepBet,
      typeof placingTermsApi.stepBet !== 'undefined',
    );
  };

  $scope.isAuctionBetInvalid = auctionBetValidate;

  const getAuctionBetErrorText = () => {
    const error = auctionBetValidate();

    if (!error) {
      return;
    }

    const { auctionMinBet, auctionMaxBet, stepBet } = placingTermsApi;

    const ERROR_TEXTS = {
      min: `Минимальная ставка — ${auctionMinBet} ₽`,
      max: `Максимальная ставка — ${auctionMaxBet} ₽`,
      multiple: `Ставка должна быть кратна ${stepBet} рублям`,
    };

    return ERROR_TEXTS[error];
  };
  $scope.getAuctionBetErrorText = getAuctionBetErrorText;

  $scope.$watch(
    () => placingTermsApi.auctionOption,
    auctionOption => {
      if (typeof auctionOption === 'object') {
        $scope.auction = auctionOption;
        $scope.auctionProgressTermNames = placingTermsApi.auctionProgressTermNames;

        calcAuctionProgress();
      }
    },
    true,
  );

  $scope.$watch('auctionProgressIconIndex', (currentIndex, prevIndex) => {
    if (typeof currentIndex !== 'undefined' && typeof prevIndex !== 'undefined') {
      const currentOptionIndex = getOptionCostIndex(placingTermsApi.selected.option);
      const isBetRasing = $scope.auctionProgressIconIndex !== currentOptionIndex;

      $scope.showAuctionChangeTermPopup(isBetRasing);
    }
  });

  $scope.$watch(
    () => addFormService.ad.areaParts,
    areaParts => {
      this.isAreaParts = isObjectSplitsCategory(this.category) && areaParts;
    },
  );

  $scope.$watch(
    () => this.auctionBet,
    (currentBet, prevBet) => {
      if (!prevBet && !!currentBet) {
        placingTermsApi.selectAdditional(placingTermsApi.auctionOption);
      }

      if (!!prevBet && !currentBet) {
        placingTermsApi.removeAdditionalById('auction');
      }
    },
  );

  const PROGRESS_IDS_MAP = {
    free: 'free',
    paid: 'paid',
    premium: 'premium',
    'premium+highlight': 'premium',
    top3: 'top3',
  };

  const PROGRESS_SERVICE_NAMES_MAP = {
    free: 'Бесплатное',
    paid: 'Платное',
    premium: 'Премиум',
    top3: 'Топ',
  };

  const getOptionCostIndex = option => {
    const id = PROGRESS_IDS_MAP[option.id];

    return placingTermsApi.auctionProgressTermNames.indexOf(id);
  };

  const getProgressRatio = (cost, min, max) => (cost - min) / (max - min);

  /**
   * Расчёт прогресса ставки.
   * Устанавливает процент, индекс и имя VAS.
   */
  const calcAuctionProgress = () => {
    const costs = placingTermsApi.auctionProgressTermCosts;

    if (!Array.isArray(costs) || costs.length < 2 || !placingTermsApi.selected) {
      return;
    }

    const sectionsCount = costs.length - 1;
    const sectionSizeInPercent = 100 / sectionsCount;

    const currentOptionIndex = getOptionCostIndex(placingTermsApi.selected.option);
    const currentOptionCost = costs[currentOptionIndex];
    const bet = this.auctionBet || 0;
    const totalCost = currentOptionCost + bet;

    let currentCostInPercent = 0;

    const currentCostIndex = costs.findIndex((cost, index) => {
      const nextCost = costs[index + 1];

      if (typeof nextCost !== 'undefined') {
        currentCostInPercent +=
          totalCost >= nextCost
            ? sectionSizeInPercent
            : sectionSizeInPercent * getProgressRatio(totalCost, cost, nextCost);
      }

      return totalCost < nextCost;
    });

    $scope.auctionProgressInPercent = keepValueInRange(currentCostInPercent, 0, 100);
    $scope.auctionProgressIconIndex = currentCostIndex === -1 ? sectionsCount : currentCostIndex;
    $scope.auctionProgressServiceId = placingTermsApi.auctionProgressTermNames[$scope.auctionProgressIconIndex];
    $scope.auctionProgressServiceName = PROGRESS_SERVICE_NAMES_MAP[$scope.auctionProgressServiceId];
  };

  $scope.showAuctionChangeTermPopup = isShow => {
    $scope.isAuctionChangeTermPopupShow = isShow;
  };

  const getAuctionBetOnServiceChange = (currentOption, nextOption, bet, betStep) => {
    const { auctionProgressTermCosts } = placingTermsApi;

    const currentOptionIndex = getOptionCostIndex(currentOption);
    const currentOptionCost = currentOptionIndex > -1 ? auctionProgressTermCosts[currentOptionIndex] : undefined;

    const nextOptionIndex = getOptionCostIndex(nextOption);
    const nextOptionCost = nextOptionIndex > -1 ? auctionProgressTermCosts[nextOptionIndex] : undefined;

    if (!Number.isFinite(currentOptionCost) || !Number.isFinite(nextOptionCost)) {
      return null;
    }

    const nextOptionBet = currentOptionCost + bet - nextOptionCost;

    return getNearestUpperMultiple(nextOptionBet, betStep);
  };

  $scope.confirmAuctionChangeTermPopup = $event => {
    $event.stopPropagation();
    $event.preventDefault();

    const { auctionProgressTermNames } = placingTermsApi;

    $scope.showAuctionChangeTermPopup(false);

    const currentOption = placingTermsApi.selected.option;

    const nextOptionName = auctionProgressTermNames[$scope.auctionProgressIconIndex];
    const nextOption = placingTermsApi.getOptionById(nextOptionName);

    this.auctionBet = getAuctionBetOnServiceChange(currentOption, nextOption, this.auctionBet, placingTermsApi.stepBet);

    placingTermsApi.selectOption(nextOption);

    applyAuctionBet();
  };

  $scope.getPenetratingForecastError = () => {
    const geo = addressService.geoObject;
    const geoId = geo && geo.geoId;
    const geoType = geo && geo.geoType;

    const { bargainTerms } = addFormService.ad;
    const price = bargainTerms && bargainTerms.price;

    const parts = [(!geoId || !geoType) && 'Адрес', !price && 'Цену объекта'].filter(Boolean);

    return parts.length ? `Укажите ${parts.join(' и ')} чтобы увидеть конкуренцию` : false;
  };

  const debouncedGetTopBets = debounce(getTopBets, 400);

  $scope.$watchGroup(
    [
      () => addFormService.ad.bargainTerms.price,
      () => addFormService.ad.areaParts?.length,
      () => getIsCommercial(addFormService.ad.category) && addFormService.ad.totalArea,
    ],
    debouncedGetTopBets,
  );
  // Аукцион ↑

  $scope.isSubscriptionOption = isSubscriptionOption;

  const filterTerms = terms =>
    Array.isArray(terms) && terms.filter(term => !['calltracking', 'auction'].includes(term.id));

  // Получаем данные из сервиса

  this.terms = placingTermsApi.terms;
  this.placingTerms = filterTerms(placingTermsApi.placingTerms);
  this.isApiFailed = false;

  this.handlePayClick = () => trackPayClick(analyticsService.adAnalyticsCategory);

  const onLoadComplete = terms => {
    this.isLoading = false;
    this.terms = placingTermsApi.terms;
    this.placingTerms = filterTerms(terms);

    const { auctionOption } = placingTermsApi;
    const isAuctionAvailable = !!auctionOption;

    const searchParams = urlService.queryParams(location.search);
    const auctionBet = Number(searchParams['auctionBet']);

    const auctionService = searchParams['auctionService'] || 'premium';
    const forcedOption = placingTermsApi.getOptionById(auctionService);

    const isAuctionForced =
      // Аукцион доступен пользователю
      isAuctionAvailable &&
      // Премиум-опция доступна пользователю
      forcedOption &&
      // Есть query-параметр auctionBet
      typeof searchParams['auctionBet'] !== 'undefined' &&
      // Query-параметр auctionBet — непустая строка
      searchParams['auctionBet'] !== '' &&
      // Query-параметр auctionBet — число
      !isNaN(auctionBet) &&
      // Нет ставки на аккаунт
      !auctionOption.isAuctionBetHolded;

    if (isAuctionForced) {
      placingTermsApi.selectOption(forcedOption);

      auctionOption.selectedPeriod.price = keepValueInRange(auctionBet, 0, placingTermsApi.auctionMaxBet);

      placingTermsApi.selectAdditional(auctionOption);
    }

    if (isAuctionSelected()) {
      this.auctionBet = getPrice(auctionOption);

      initializeAuctionBet();

      if (!isAuctionSelectedFirstTime) {
        trackAuctionBlockOpen(auctionOption.isAuctionBetHolded);

        isAuctionSelectedFirstTime = true;
      }
    }

    this.multiPostingExperimentGroup = placingTermsApi.multipostingABGroup;

    const regionId = geoService.getLocationId();
    const platforms = getPlatforms(config, this.multiPostingExperimentGroup, regionId);
    const multiPostingFreeDate = config.get('multiPosting.freeDate');
    const multiPostingLabelText = getLabelText(multiPostingFreeDate, this.multiPostingExperimentGroup);
    this.multiPostingData = {
      label: multiPostingLabelText,
      text: getText(config, this.multiPostingExperimentGroup, regionId),
      termsUrl: config.get('addformConfig.multiPosting.termsUrl'),
      platformsText: platforms.length
        ? `${platforms.length} ${plural(platforms.length, ['площадке', 'площадках', 'площадках'])}`
        : '',
      tooltipText: platforms.join(', '),
    };

    if (this.onLoadComplete) {
      this.onLoadComplete();
    }

    if (isAuctionForced) {
      $rootScope.$emit('scrollTo', 'ad-placing-terms');
    }
  };

  placingTermsApi.init({
    onStartLoading: () => {
      // Показываем прелоадер
      this.isLoading = true;
    },
    onSuccess: terms => {
      try {
        onLoadComplete(terms);

        this.isApiFailed = false;

        // Сохраняем выбор после обновления данных
        placingTermsApi.updateAdditionals(placingTermsApi.selected.option);
        save(true);
        setTimeout(() => {
          telemetryService.mark('terms.api-data-render-end');
          telemetryService.sendMeasuredTimer(
            'terms.api-data-rendered',
            'terms.publish-terms-end',
            'terms.api-data-render-end',
          );
        });

        if (placingTermsApi.selected.option) {
          placingTermsApi.selected.option.showHint = true;
        }

        // после обновления проверяем доступность сохраненных услуг, чтобы поменять текст кнопки "разместить"
        // и показать сообщение в случае недоступности
        if (this.publishTerms.terms && this.publishTerms.terms.length) {
          checkServiceAvailabilityDebounced(true);
        }

        // ФВУ успешно отрендерится, если запрос /publish-terms/ успешен и
        // обработка данных после запроса произошла без ошибок
        telemetryService.increment('publish-terms.render.success');
      } catch (err) {
        // ФВУ не отрендерится (либо отрендерится, но с ошибками), если запрос /publish-terms/ успешен, но
        // обработка данных после запроса произошла с ошибками
        telemetryService.increment('publish-terms.render.fail');
      }
    },
    onFail: () => {
      // ФВУ не отрендерится, если запрос /publish-terms/ неуспешен
      telemetryService.increment('publish-terms.request.fail');

      onLoadComplete();
      // В случае ошибки показываем соответствующее сообщение
      this.isApiFailed = true;
    },
    onCheckServiceRequestStart: this.onCheckServiceRequestStart,
    onCheckServiceRequestFinish: this.onCheckServiceRequestFinish,
  });

  $scope.$watch(
    () => placingTermsApi.selected.option,
    (newOption, prevOption) => {
      if (!isEmpty(prevOption) && !isEmpty(newOption) && prevOption.id !== newOption.id) {
        $scope.auctionProgressIconIndex = getOptionCostIndex(newOption);

        $scope.showAuctionChangeTermPopup(false);

        placingTermsApi.updateBetData();

        const { auctionOption, stepBet } = placingTermsApi;

        if (!auctionOption) {
          return;
        }

        const auctionBet = getAuctionBetOnServiceChange(prevOption, newOption, bet, stepBet);

        const bet = getPrice(auctionOption) || auctionBet;

        this.auctionBet = getNearestUpperMultiple(bet, stepBet);

        handleAuctionChange();

        calcAuctionProgress();
      }
    },
  );

  $scope.handleAuctionChangeTermPopupClose = $event => {
    $event.stopPropagation();
    $event.preventDefault();

    $scope.showAuctionChangeTermPopup(false);
  };

  $scope.getFailedMessage = () => {
    const state = store.getState();
    const isSaveDraftAvailable = selectIsSaveDraftButtonAvailable(state);

    return (
      (isSaveDraftAvailable && 'Сохраните ваше объявление в черновик и повторите попытку позднее.') ||
      'Повторите попытку позднее.'
    );
  };

  const getIsByHomeowner = () => addFormService.ad.isByHomeowner;

  $scope.identificationLinkClick = () => {
    $rootScope.$broadcast('identification.runSumsub');
  };

  // Следим за изменениями параметров запроса, чтобы на ходу обновить данные
  $scope.$watch(
    () => {
      const { bargainTerms, totalArea, category, areaParts, photos } = addFormService.ad;

      const state = store.getState();
      const extraData = selectDynamicPricingParameters(state);

      const params = {
        locationPath: this.locationPath || null,
        category: this.category || null,
        latitude: this.latitude || null,
        longitude: this.longitude || null,
        photosCount: this.photosCount || null,
        isMultiListing: addFormService.isObjectSplits(),
        additionalDataToRequest: this.additionalDataToRequest || {},
        isByHomeowner: getIsByHomeowner(),
        extraData,
      };

      const isCommercial = !!category && getIsCommercial(category);

      if (isCommercial) {
        /**
         * Для правильной работы билинга с мультиобъявками мы здесь учитываем следующий случай:
         * 1) есть старая мульти объявка с фото с тарифом ТОП (тариф не доступен без фото)
         * 2) она открывается на редактирование в ФП с новым флоу по мульти
         * 3) в этой ФП юзер не видит фото, т.к. у мульти в новом флоу загрузка фото для всей объявки отключена
         * 4) если пользователь не добавил фото в какой-то из слотов - у него не будет возможности публикации ТОП
         * 5) т.о. юзер теряет возможность публикации в том же ТОП тарифе, который был ранее
         *
         * Как работает:
         * - смотрим на фото слотов - если есть, то считаем их
         * - если фото слотов нет, то смотрим на фото самой объявки - если есть, считаем их
         * - если нет ни того, ни другого - 0
         */
        const photosCount = (() => {
          if (addFormService.isObjectSplits()) {
            const areaPartsPhotosLength =
              areaParts?.reduce((acc, areaPart) => {
                return acc + areaPart.photos.length;
              }, 0) ?? 0;

            return (photos?.length ?? 0) + areaPartsPhotosLength;
          }

          return this.photosCount || null;
        })();

        Object.assign(params, {
          price: bargainTerms && bargainTerms.price,
          currency: bargainTerms && bargainTerms.currency,
          priceType: bargainTerms && bargainTerms.priceType,
          paymentPeriod: bargainTerms && bargainTerms.paymentPeriod,
          totalArea,
          photosCount,
          multiListingSlotsCount: areaParts?.length ?? null,
        });
      }

      return params;
    },
    newParams => {
      const { additionalDataToRequest, isMultiListing, category, locationPath, ...restParams } = newParams;

      placingTermsApi.setAdditionalData({ ...additionalDataToRequest });

      if (offerId || (category && locationPath)) {
        const reasons =
          Array.isArray(mlRegions) && mlRegions.some(region => locationPath.includes(region))
            ? unavailableReasonsML
            : unavailableReasons;

        unavailableReasonsWithHtml = mapValues(reasons, r => ({
          ...r,
          html: $sce.trustAsHtml(r.hint),
        }));

        const updateTermsParams = {
          category,
          locationPath,
          ...(isObjectSplitsCategory(category) && { isMultiListing }),
          ...restParams,
        };

        placingTermsApi.updateTerms(updateTermsParams);
      } else {
        // Если категория не указана, то не пытаемся запрашивать новые данные
        placingTermsApi.resetTerms();
      }
    },
    true,
  );

  $scope.$watch(
    () => advertiseObjectService.isCanAdvertiseObject(),
    newValue => {
      const oldAdvertiseVisibleValue = this.advertiseMyObjectVisible;
      this.advertiseMyObjectVisible = newValue && ['A', 'B'].includes(this.adMyObjectABGroup);

      // Перед отправкой аналитики нужно проверить, что мы показываем блок и что мы начали показывать блок
      if (this.advertiseMyObjectVisible && this.advertiseMyObjectVisible !== oldAdvertiseVisibleValue) {
        analyticsService.trackAdvertiseCheckboxShow();
      }
      // Если чекбокс пропал из-за смены категории, то обнуляем чекбокс
      if (!this.advertiseMyObjectVisible) {
        this.setAdMyObjectStatus(false);
      }
    },
  );

  $scope.$on('$destroy', () => {
    removeTermsChangedHandler();
  });

  $scope.$watch(
    () => addFormService.ad.isByHomeowner,
    newValue => {
      this.showDemandTrap =
        newValue &&
        !this.hasActiveMessages &&
        (this.isInExperiment || !get(addFormService, 'ad.dealRentData.applyDealRentVersion'));

      if (this.showDemandTrap && newValue !== this.isByHomeowner) {
        trackShowCheckbox(adStateService.isNewOffer);
      }

      if (!this.showDemandTrap) {
        placingTermsApi.isRealtorHelpNeeded = false;
      }
      this.isByHomeowner = newValue;
    },
  );
}
